var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","title":"Invalider ce point"},on:{"click":function($event){return _vm.unsolveItem()}}},[_c('i',{staticClass:"far fa-fw fa-check-square text-secondary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }